<template>
  <div id="components-popover-demo-placement">
    <div style="padding: 10px;">
      <a-popover  placement="right" v-for="(item,i) in treelist"  :key="i">
        <!-- <span slot="title" style="color:#108ee9;font-size: 16px;font-weight: 600; ">{{ item.title }}</span> -->
        <template slot="content">
            <div class="secord"  @mouseleave="hide">
              <div v-if="item.children">
                <a-row v-for="(secord,s) in item.children"  :gutter="16" :key="s">
                  <a-col :span="4"> 
                    <div class="stag" @click="onchangeSecord">
                      <div class="stitle">{{secord.title}}</div>
                      <a-icon type="right" :style="{ fontSize: '14px',alignSelf:'center'}"/>                     
                    </div>
                  </a-col>
                  <a-col :span="20"> 
                    <div class="third">
                      <template v-for="(third,t) in secord.children">
                        <a-checkable-tag v-model="third.checked"  @change="handleChange(item.key,third.key,secord.key,third.title)">
                          <span style="font-size: 14px;">{{third.title}}</span>
                        </a-checkable-tag>
                      </template>
                    </div>                      
                  </a-col>
                </a-row>
              </div>
              <div v-else>
                <div style="text-align: center;">
                  <img :src="noDataPng" style="width: 50%;height: auto;" />
                </div>                  
              </div>                
            </div>
        </template>
        <a-row class="out-row">
          <a-col :span="5"> 
              <div class="out-stag" ><span class="out-stitle">{{item.title}}</span></div>
          </a-col>
          <a-col :span="18">           
              <div class="out-secord">
                <span v-for="(secordItem ,index2) in item.children" :key="index2">{{secordItem.title}}
                  <span style="margin: 0 5px;" v-if="index2 < (item.children.length-1)"> | </span>
                </span>
              </div>                      
          </a-col>
          <a-col :span="1">
              <div class="out-secord-icon"><a-icon type="caret-right" :style="{ fontSize: '16px',alignSelf:'right',color:'grey'}"/> </div>
          </a-col>
        </a-row> 
      </a-popover>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage';
import noDataPng from '@/assets/nodata.png';
export default {
  name: 'LabelTagSelected',
  props: {

  },
  data() {
    return {
      queryParam: {
        topId: '',
        managerId: [],
        labels: [],
        tagsList: []
      },
      width:800,
      noDataPng:'',
      treelist:[],
      url: {
        queryLableTree:'/api/queryLableTree'
      },
    }
  },

  created() {
    this.noDataPng = noDataPng;
    this.queryLableTree();
  },

  methods: {
    /**
     * 加载标签树
     */
    queryLableTree(){
      const that = this;
      getAction(this.url.queryLableTree, {}).then((res) => {
        if (res.success) {
          that.treelist =  res.result;
        } else {
          that.$message.warning(res.message)
        }
      })
    },  
    /**
     * 选择二级标签
     * @param e 
     */
    onchangeSecord(e){
      console.log('选择二级标签')     
      // this.queryParam.managerId = e.key;
      // this.queryParam.topId = e.parentId;
    },
    /**
     * 选择三级标签
     * @param checked 
     */
    handleChange(topId,labelId, managerId, title) {
      console.log('选择三级标签');    
      
      let tagsList = this.queryParam.tagsList;
      var tags = this.queryParam.labels;
      var mtags = this.queryParam.managerId;
      var ttags = this.queryParam.topId;
      // console.log('前',tags);

      if (tags.indexOf(labelId) === -1) {
        tags = [...tags, labelId];
        if(mtags.indexOf(managerId) === -1){
          mtags = [...mtags, managerId];
          this.queryParam.managerId = mtags;
          if (ttags.indexOf(topId) === -1) {
            ttags = [...ttags, topId];
            this.queryParam.topId = ttags;
          }
        }
        tagsList.push({
          labelId: labelId,
          labelName: title
        })
      }else{
        tags = tags.filter(tag => tag !== labelId);
        tagsList = tagsList.filter(tag => tag.labelId !== labelId);
      }
      // console.log('后',tags);
      this.queryParam.tagsList = tagsList;
      this.queryParam.labels = tags;
      
      console.log('--------------------跳转产品中心-----------------')
      console.log(this.queryParam);
      this.$emit("addLabel", this.queryParam);
    },
    /**
     * 关闭
     */
    hide(){
      // console.log('移出',this.queryParam);
      // this.$emit("initList", this.queryParam);
    },
  },
}
</script>

<style scoped>
  .gray{
    color: #9a9a9a;
  }
  .out-stag{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    line-height: 32px;
  }
  .out-stitle{
    font-weight: 600;
    font-size: 16px;
    line-height: 32px;
  }
  .out-secord{
    line-height: 32px;
    font-size: 14px;
    color: #9a9a9a;
    max-height: 64px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .out-secord-icon{
    line-height: 32px;
    font-size: 16px;
    text-align: end;
  }
  .out-row{
    padding: 10px;
  }
  .out-row:hover { 
    text-decoration: underline; 
    color: #108ee9; 
    background: #e6f7ff;
   
  }
  .out-secord:hover{
    color: #108ee9; 
  }
  .right-20{
    margin-right: 20px;
  }
  
  .secord{
    width: 800px;
    padding:10px 0;
    /* min-height: 380px; */
  }
  .stag{
    display: flex;
    justify-content: space-between;
    line-height: 32px;
  }
  .stitle{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 600;
    font-size: 14px;
  }
  .stag:link{
    text-decoration: none;
    color: #000000A6;
  } 
  .stag:visited{
    text-decoration: none;
    color: #108ee9;
  } 
  .stag:hover { 
    text-decoration: underline; 
    color: #108ee9; 
  }
  .third{
    line-height: 32px;
    font-size: 14px;
  }
</style>